import * as XLSX from "xlsx";
import { get } from "../../core/fetch.core";
import { useTranslation } from "../../core/translation.core";
import ArrowDownTrayIcon from "../../icons/arrowDownTray.icon";
import { useState } from "react";
import { set } from "nprogress";

interface ExportResponse {
  products: Array<any>;
}

export default function ProductExport() {
  const { t, msg } = useTranslation();
  const [loading, setLoading] = useState(false);
 

  const handleExport = async () => {
    try {
      setLoading(true);
      // Get the export data from API
      const response = await get<ExportResponse>("/admin/product/export");
      const products = response.data.products;

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(products);

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Products");

      // Generate and download file
      XLSX.writeFile(wb, `products_export_${new Date().toISOString().split("T")[0]}.xlsx`);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export failed:", error);
    }
  };

  return (
    <>
      {loading ? <span className="animate-spin rounded-full h-6 w-6 border-b-2 border-her-robinEggBlue mx-2"></span> : 
      <button
        id="product-export"
        onClick={handleExport}
        className="p-2 text-her-robinEggBlue hover:scale-125 rounded-full transition-colors"
        title={t(msg.product.export)}
      >
        <ArrowDownTrayIcon className="w-6 h-6" />
      </button> 
    }
    </>
  );
}
